const en = {
  close: "Close",
  sorryPageNotAvailable: "Sorry, this page isn't available",
  tryAgainLater:
    "Try again later in a few minutes. If this problem persists, get in contact with customer care.",
  details: "Details",
  operationId: "Operation ID",
  courseTitle: "Course Title",
  format: "Format",
  courseDate: "Course Date",
  facultyRole: "Faculty Role",
  status: "Status",
  courseStatus: "Course Status",
  viewAgreementDetails: "View Agreement Details",
  documentDate: "Document Date",
  showOnlyDocsRequireAttention:
    "Show only documents that require my attention",
  accepted: "Accepted",
  actionNeeded: "Action Needed",
  claimCredit: "Claim Credit",
  creditClaimed: "Credit Claimed",
  alreadyClaimedCreditTooltip:
    "You have already claimed credit for this course.",
  eventNotEndedTooltip:
    "This event has not yet ended. After the event has ended, come back to this page and claim credit.",
  processing: "Processing...",
  agreementActions: "Agreement Actions",
  agreement: "Agreement",
  acceptAgreement: "Accept Agreement",
  acceptedAgreementContactTooltip:
    "You have accepted this Agreement, if you think this is a mistake get in contact with {contact}",
  backToCourseDetails: "Back to Course Details",
  backToMyCourses: "Back to My Courses",
  courseActions: "Course Actions",
  webinar: "Webinar",
  joinWebinar: "Join Webinar",
  preview: "Preview",
  facultyPortal: "Faculty Portal",
  collapseMenu: "Collapse Menu",
  startDate: "Start date",
  endDate: "End date",
  siteNotFoundTitle: "The site you are looking for does not exists",
  unauthorized: "Unauthorized",
  pageNotFoundMsg:
    "The page you have requested does not exist or could not be found",
  contactSupportForAssistance: "Please contact customer support for assistance",
  dueDate: "Due Date",
  viewAgreement: "View Agreement",

  /* Accessible names for the page tables */
  myCourses: "My Courses",
  myDocuments: "My Documents",
  agreementDetails: "Agreement Details",
};

export default en;
